import { render, staticRenderFns } from "./OrderMetadataItem.vue?vue&type=template&id=9f8b88a6&scoped=true&"
import script from "./OrderMetadataItem.vue?vue&type=script&lang=ts&"
export * from "./OrderMetadataItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderMetadataItem.vue?vue&type=style&index=0&id=9f8b88a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8b88a6",
  null
  
)

export default component.exports